/* istanbul ignore file */

const customTextRegExr = /^shop\.text\.[a-z0-9.]+$/i;

export const parametersRegularExpressions = [customTextRegExr];
